export const setEvaluatorInterviewDates = (payload) => {
  return {
    type: 'SET_EVALUATOR_INTERVIEW_DATES',
    payload,
  };
};
